import PropTypes from "prop-types";

export const AnalyticsPropTypes = PropTypes.shape({
  contentType: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  sourcePage: PropTypes.string,
  sourcePageType: PropTypes.string,
  sourceElement: PropTypes.string,
  sourceName: PropTypes.string,
});
